import { useState, useEffect } from 'react';

export function useDeviceLayout() {
  const [layoutMode, setLayoutMode] = useState('desktop');

  useEffect(() => {
    function calculate() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      // Shortest side — Android landscape stays phone mode (width can exceed 768px).
      const shortest = Math.min(width, height);
      const isTouch = window.matchMedia('(pointer: coarse)').matches;
      const hasHover = window.matchMedia('(hover: hover)').matches;

      if (shortest < 768) {
        setLayoutMode('phone');
      } else if (width >= 768 && width <= 1280 && isTouch && !hasHover) {
        setLayoutMode('tablet');
      } else {
        setLayoutMode('desktop');
      }
    }
    calculate();
    window.addEventListener('resize', calculate);
    window.addEventListener('orientationchange', calculate);
    return () => {
      window.removeEventListener('resize', calculate);
      window.removeEventListener('orientationchange', calculate);
    };
  }, []);

  return layoutMode;
}
